import { collection, deleteDoc, doc, getDoc, setDoc, Timestamp, updateDoc, } from "firebase/firestore";
import { prepareForFirestore } from "./utils";
export const adminActionConverter = {
    toFirestore(value) {
        const action = value;
        return {
            ...prepareForFirestore(action),
            ...("processingFailure" in action && {
                processingFailure: action.processingFailure
                    ? {
                        ...action.processingFailure,
                        failedAt: toTimestampOrNull(action.processingFailure.failedAt),
                    }
                    : null,
            }),
            ...("dueDate" in action && {
                dueDate: toTimestampOrNull(action.dueDate),
            }),
            ...("completedAt" in action && {
                completedAt: toTimestampOrNull(action.completedAt),
            }),
            ...("feedbackSubmittedAt" in action && {
                feedbackSubmittedAt: toTimestampOrNull(action.feedbackSubmittedAt),
            }),
        };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return {
            ...data,
            ...("processingFailure" in data && {
                processingFailure: data.processingFailure
                    ? {
                        ...data.processingFailure,
                        failedAt: data.processingFailure.failedAt instanceof Timestamp
                            ? data.processingFailure.failedAt.toDate().toISOString()
                            : (data.processingFailure.failedAt ?? null),
                    }
                    : null,
            }),
            id: snapshot.id,
            createdAt: data.createdAt instanceof Timestamp
                ? data.createdAt.toDate().toISOString()
                : data.createdAt || null,
            updatedAt: data.updatedAt instanceof Timestamp
                ? data.updatedAt.toDate().toISOString()
                : data.updatedAt || null,
            dueDate: data.dueDate instanceof Timestamp
                ? data.dueDate.toDate().toISOString()
                : data.dueDate || null,
            completedAt: data.completedAt instanceof Timestamp
                ? data.completedAt.toDate().toISOString()
                : data.completedAt || null,
            feedbackSubmittedAt: data.feedbackSubmittedAt instanceof Timestamp
                ? data.feedbackSubmittedAt.toDate().toISOString()
                : data.feedbackSubmittedAt || null,
        };
    },
};
function toTimestampOrNull(value) {
    if (!value)
        return null;
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
        throw new Error("Invalid date value.");
    }
    return Timestamp.fromDate(date);
}
export function adminActionsCollection(db) {
    return collection(db, "adminActions").withConverter(adminActionConverter);
}
export function adminActionDocument(db, id) {
    return doc(db, "adminActions", id).withConverter(adminActionConverter);
}
export async function fetchAdminAction(db, id) {
    const snapshot = await getDoc(adminActionDocument(db, id));
    return snapshot.exists() ? snapshot.data() : null;
}
export async function createAdminAction(db, data) {
    const docRef = doc(adminActionsCollection(db));
    await setDoc(docRef, {
        ...data,
        id: docRef.id,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    });
    return docRef.id;
}
export async function updateAdminAction(db, id, data) {
    const docRef = adminActionDocument(db, id);
    await updateDoc(docRef, {
        ...data,
        updatedAt: new Date().toISOString(),
    });
}
export async function deleteAdminAction(db, id) {
    await deleteDoc(adminActionDocument(db, id));
}
